module.exports = __webpack_public_path__ + "static/media/good.a2baa43a.jpg";